import { make, dispatch, commit } from 'vuex-pathify';
import BookingFlowService from '../../services/booking-flow/service';
import * as _ from "lodash";

const state = {
  vehicles: [],
  method: "Checkout",
  travelDetails: {
    known: false,
    outbound_terminal: null,
    outbound_flight: '',
    return_terminal: null,
    return_flight_number: '',
    meet_time: '',
    destination: 'NA',
    destination_country: 0,
    destination_airport: 0,
    parking_arrival_time: '12:00',
    parking_departure_time: '12:00'
  },
  multiCar: true,
  complete: false,
  redirect: null,
  needVehicle: true,
  error: '',
  confirmed: false,
  confirmation: null,
  editTimes: false,
  amend: false,
  inProgress: false
};

const vehicle = () => {
  return {
    vehicle_make: '',
    vehicle_model: '',
    vehicle_colour: '',
    vehicle_reg: '',
    no_passengers: 1,
    response: '',
    existing: null,
  }
}

const mutations = {
  ...make.mutations(state),
  paymentInProgress(state, value) {
    state.inProgress = value
  }
}

const actions = {
  ...make.actions(state),

  toggleProgress({ commit }, value) {
    commit('paymentInProgress', value)
  },

  // send token to checkout to generate redirect url
  async sendToken({ dispatch }, payload) {

    let basket = [
      ...this.state.cart.products.airportparking,
      ...this.state.cart.products.airporthotel,
      ...this.state.cart.products.airportlounge,
      ...this.state.cart.products.addon,
    ]

    let cart = basket.map( item => {

      let product = item.product;
      let quantity = item.quantity ? item.quantity : product.category === 'airportparking' ? this.state.payment.vehicles.length : 1;

      return {
        product_id: product.product_id, 
        price: product.full_price,
        priceItem: product.session_key,
        category: product.category || 'addon',
        discount: product.discount,
        serviceCode: product.serviceCode || null,
        quantity,
        quote: item.quote
      }
    })

    let booking = {
      customer: this.state.customer,
      cart: cart,
      travel: this.state.payment.travelDetails,
      vehicles: this.state.payment.vehicles,
      ...payload
    }

    dispatch('setError', '');

    await BookingFlowService.token(booking).then(response => {

      if(response['data'].success) return dispatch('setRedirect', response['data'].redirect);
      dispatch('setError', 'payment.payment.error.failed');
    }).catch(error => {
      if (error.response) {
        dispatch('setError', 'payment.payment.error.wrong_try_again');
        window.location.reload()
      } else {
        dispatch('setError', 'payment.payment.error.wrong_try_again_cs');
      }
    });
  },

  // confirm booking has been made
  async confirm(context, payload) {
    await BookingFlowService.confirm(payload).then(response => {

      if(response["data"].success == true || response["success"] === true) {
        context.dispatch('setConfirmed', true);
        context.dispatch('setError', '')

        // booking has been made, we can now clear the old cart
        dispatch('cart/resetCart');
      } else {

        let message = response["data"].message;
        let messages = {
          'BOOKING_ALREADY_EXISTS' : 'payment.payment.error.already_exists'
        }
        context.dispatch('setError', messages[message])
      }
    }).catch( res => {

      // failed booking - clear cart
      dispatch('cart/resetCart');

      if(res.response && res.response["data"].message === 'BOOKING_FAILED') {
        if(res.response["data"].details) {
          if(res.response["data"].message && res.response["data"].details.data.details.indexOf('QUOTE_EXPIRED') > -1) return context.dispatch('setError', 'payment.payment.error.expired');
          if(res.response["data"].message && res.response["data"].details.data.details.indexOf('BOOKING_ALREADY_EXISTS') > -1) return context.dispatch('setError', 'payment.payment.error.already_exists');
          if(res.response["data"].message && res.response["data"].details.data.details.indexOf('CREDITS_EXPIRED') > -1) return context.dispatch('setError', 'payment.payment.error.credits');
        }
        return context.dispatch('setError', 'confirmation.error_not_created_contact');
      }

    });
  },

  // get booking details using id
  async confirmation({ dispatch }, payload) {
    await BookingFlowService.getBooking(payload).then(response => {

      if(response["data"].success == false) {
        return dispatch('setError', 'confirmation.booking_not_found');
      } else {
        dispatch('setConfirmation', response["data"]);
        return dispatch('setError', '')
      }
    }).catch(() => dispatch('setError', 'confirmation.booking_not_found'));
  },

  // lookup registration plate
  async registrationLookup(context, index) {
    await BookingFlowService.regLookup(this.state.payment.vehicles[index].vehicle_reg).then(response => {

      let vehicles  = _.cloneDeep(this.state.payment.vehicles)
      vehicles[index].response = response.data.status;

      if(response['data'].status !== 'error') {
        vehicles[index] = { no_passengers: vehicles[index].no_passengers, existing: null, response: '', ...response.data }
      }

      dispatch('payment/setVehicles' , vehicles);
    })
  },
  
  // add vehicle to the vehicles array
  addEmptyVehicle({ dispatch }) {
    let vehicles  = _.cloneDeep(this.state.payment.vehicles)
    vehicles.push(vehicle())
    dispatch('setVehicles', vehicles);
    commit('cart/updateDefaultAddons');
  },

  // remove last item from vehicles array
  removeVehicle({ dispatch }, index) {
    let vehicles  = _.cloneDeep(this.state.payment.vehicles)
    vehicles.splice(index, 1)
    dispatch('setVehicles', vehicles);
    commit('cart/updateDefaultAddons');
  },

  // updates vehicles array
  updateVehicle({ dispatch }, data) {
    let vehicles  = _.cloneDeep(this.state.payment.vehicles)
    vehicles[data.index] = data['vehicle']
    vehicles[data.index].response = ''
    dispatch('setVehicles', vehicles);
  }
};

export default {
  namespaced: true,
  actions,
  mutations,
  state
};